import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, type SessionKind } from '@/lib/auth-store';

interface Props {
  children: React.ReactNode;
  kind?: SessionKind;
}

export default function ProtectedRoute({ children, kind }: Props) {
  const location = useLocation();
  const { accessToken, kind: currentKind, hydrated } = useAuthStore();

  if (!hydrated) {
    return (
      <div className="flex h-screen-safe items-center justify-center text-gray-500">
        Carregando...
      </div>
    );
  }

  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (kind && currentKind !== kind) {
    // logged in but wrong role → redirect to a safe default
    const fallback = currentKind === 'FUNCIONARIO' ? '/bater-ponto' : '/admin';
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
